import { computed } from 'vue';
import { FirebaseKeys, useFirebaseStore } from '@/shared/composables/feature-toggle';

export function useIsB2SActive() {
  const firebaseStore = useFirebaseStore();
  const isB2SActive = computed(() => firebaseStore.features[FirebaseKeys.B2S_CAMPAIGN]);

  return {
    isB2SActive,
  };
}
